import Image from "next/image";

type PawLoaderProps = {
  label?: string;
  className?: string;
};

export function PawLoader({
  label = "Načítání",
  className = "py-16",
}: PawLoaderProps) {
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      role="status"
      aria-live="polite"
    >
      <Image
        src="/image/paw/paw.svg"
        alt=""
        aria-hidden="true"
        height={55}
        width={55}
        className="h-14 w-14 animate-ping"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
